import { useEffect, useState } from 'react';
import debounce from './debounce';

interface WindowSize {
    width: number;
}

function useWindowWidth(delay = 500, enabled = true): WindowSize {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!enabled) return undefined;
        let active = true;
        const handleResize = () => {
            if (active) setWidth(window.innerWidth);
        };
        const debouncedHandleResize = debounce(handleResize, delay);

        handleResize();

        window.addEventListener('resize', debouncedHandleResize);
        return () => {
            active = false;
            window.removeEventListener('resize', debouncedHandleResize);
        };
    }, [delay, enabled]);

    return { width };
}

export default useWindowWidth;
